export const imagePathsSsh = {
  480: "/care/hospitalAtHome480.avif",
  768: "/care/hospitalAtHome768.avif",
  1366: "/care/hospitalAtHome1366.avif",
};
